// extracted by mini-css-extract-plugin
export default {"container":"GradeTooltip_container__mH07Y","gradeLabel":"GradeTooltip_gradeLabel__cVpmk"};